<mat-card>
    <mat-card-content>
        <h2>{{'help.maintenance.fullLabel' | translate}}</h2>
        <div [innerHTML]="'help.maintenance.detail' | translate"></div>
    </mat-card-content>
</mat-card>
